
import Freegames from "./freegames";
import Barrel from "./rx_barrel";
import { REQUEST_TYPE } from "./network/net";
const network = require( './network/network_api' );
import { TYPE, canGo, cannotGo, canOnlyGo } from "./network/network_api";
import Stream from "./frp/stream";

/* We have our own (client-side) intermediate states within server-wise FINISH state:
* server: FINISH                                            ->                                                  FINAL
* client: FINISH  ->  table(F1)  ->  enable "finish" btn (F_2)  ->  click "finish"(F_3) -> risk/collect(F_4) -> FINAL
*/
export const FINISHING_STATES =
{
    NONE : 1,
    SHOWING_TABLE : 2,
    FINISH_INVITATION : 3,
    ENDING : 3.5,
    RISK_INVITATION : 4,
};

export default function(
    parent,
    ui,
    leaves,
)
{
    const space = parent.child( "slot" );
    
    const $state = parent.s( "state" );
    const $request = parent.s( "request" );
    const $pending = parent.s( "pending" );
    
    const $displayingWin = space.s( "displayingWin", false );
    const $animating = space.s( "animating", false );
    
    //REGULAR game:
    const barrel = Barrel(
        space,
        $state.filter( state => state.type == network.TYPE.REGULAR || state.type == network.TYPE.FREEGAME ),
    );
    const $initiate = barrel.s( "initiate" );
    const $spinStartSlot = leaves.slot.space.s( "spinStart" );
    const $spinStartFreegames = leaves.freegames.space.s( "spinStart" );
    const $start = leaves.barrel.space.s( "start" );
    barrel.s( "start" )
        .withLatestFrom( $state, ( start, state ) => ({ start, state }) )
        .subscribe( ({ start, state }) => {
            let isFreegames = false;
            //freegames' $spinStart must be called BEFORE barrel.$start:
            if (
                //within freegames:
                state.type == network.TYPE.FREESPIN
                ||
                //when initiating first freespin:
                ( ! start && network.canOnlyGo( network.TYPE.FREESPIN, state ) )
            )
            {
                isFreegames = true;
                $spinStartFreegames.next( {
                    freespinNumber : state.server.freespinNumber + ( start ? 0 : 1 ),
                    freespinsCount : state.server.freespinsCount - ( start ? state.server.freespinsIncrease : 0 ),
                    math : state.state.stage.math,
                    server : state.server,
                    restore : ( start ? true : false )
                } );
            }
            else
            {
                $spinStartSlot.next( state );
            }
            
            $start.next( {
                isFreegames,
                previousSymbols : state.state.stage.math.symbols,
                newSymbols : start ? start.state.stage.math.symbols : undefined,
                server : state.server
            } );
        } );
    barrel.s( "stop" ).subscribe( leaves.barrel.space.s( "end" ) );
    $state
        .filter( state => state.type != TYPE.REGULAR && state.type != TYPE.FREESPIN )
        .map( state => state.server.math.symbols )
        //now game has FINISH states for bonuses as well (no reels visible at the time):
        .filter( symbols => symbols )
        .subscribe( leaves.barrel.space.s( "static" ) );
    
    // ui_view -> barrel:
    leaves.ui.space.s( "stop" ).subscribe( barrel.s( "interruptUser" ) );
    leaves.ui.space.s( "spin" ).subscribe( $initiate );
    leaves.barrel.space.s( "click" ).to( leaves.ui.space.s( "barrelClick" ) );
    
    //regular spin:
    barrel.s( "request" )
        .withLatestFrom( $state, ( r, state ) => state )
        .filter( state => network.cannotGo( network.TYPE.FREEGAME, state.state ) )
        .withLatestFrom( leaves.ui.space.s( "betValue" ), ( state, betValue ) => ({
            lines : betValue.lines,
            multiplier : betValue.multiplier,
            type : REQUEST_TYPE.SPIN,
        }) )
        .subscribe( $request );
    //freespin:
    barrel.s( "request" )
        .withLatestFrom( $state, ( r, state ) => state )
        .filter( state => network.canGo( network.TYPE.FREEGAME, state.state ) )
        .map( () => ({ type : REQUEST_TYPE.PROCEED }) )
        .subscribe( $request );
    
    //slot scene:
    leaves.ui.space.s( "betValue" )
        .take( 1 )
        .subscribe( leaves.slot.space.s( "initial" ) );
    leaves.ui.space.s( "linesValue" )
        .distinctUntilChanged( _.isEqual )
        .pairwise()
        .subscribe( leaves.slot.space.s( "linesChange" ) );
    leaves.ui.space.s( "multiplierValue" )
        .distinctUntilChanged( _.isEqual )
        .pairwise()
        .subscribe( leaves.slot.space.s( "multiplierChange" ) );
    ui.s( "resultBet" )
        .map( c => c.bet )
        .subscribe( leaves.slot.space.s( "bet" ) );
    /*temp:*/$state
        .filter( state => state.type == network.TYPE.REGULAR || state.type == network.TYPE.FREESPIN )
        .subscribe( state => leaves.slot.slotScene.dataDidReceived && leaves.slot.slotScene.dataDidReceived( state.state.stage.math ) );
    
    const $isFreegames = $state.map( state => state.type == network.TYPE.FREEGAME );
    const $reelStopSlot = leaves.slot.space.s( "reelStop" );
    const $reelStopFreegames = leaves.freegames.space.s( "reelStop" );
    leaves.barrel.space.s( "reelStop" )
        .withLatestFrom( $isFreegames, ( stop, isFreegames ) => ({ stop, isFreegames }) )
        .subscribe( ({ stop, isFreegames }) => {
            if ( isFreegames ) $reelStopFreegames.next( stop );
            else $reelStopSlot.next( stop );
        } );
    const $spinStopFreegames = leaves.freegames.space.s( "spinStop" );
    const $spinStopSlot = leaves.slot.space.s( "spinStop" );
    leaves.barrel.space.s( "stop" )
        .withLatestFrom( $isFreegames, ( stop, isFreegames ) => ({ stop, isFreegames }) )
        .subscribe( ({ stop, isFreegames }) => {
            if ( isFreegames ) $spinStopFreegames.next( stop );
            else $spinStopSlot.next( stop );
        } );
    
    Freegames(
        $state,
        leaves.freegames,
    );
    const $beginningFeature = leaves.ui.space.s( "beginningFeature", false );
    leaves.ui.space.s( "start" )
        .withLatestFrom( $state, ( i, state ) => state )
        .on( state => {
            let leaf = undefined;
            if ( canGo( TYPE.FREEGAME, state ) ) leaf = leaves.freegames.space;
            if ( canGo( TYPE.BONUS_1, state ) ) leaf = leaves.bonus.space;
            if ( canGo( TYPE.BONUS_2, state ) ) leaf = leaves.superbonus.space;
            if ( leaf )
            {
                $beginningFeature.next( true );
                leaf.s( "begin" ).next( state );
            }
        } );
    const $interruptWinShow = leaves.slot.space.s( "interruptWinShow" );
    leaves.freegames.space.s( "beginComplete" )
        //interrupt regular spin win display:
        .withLatestFrom( $displayingWin, ( p, d ) => d )
        .subscribe( d =>
        {
            $beginningFeature.next( false );
            if ( d )
            {
                $displayingWin.next( false );
                $interruptWinShow.next();
            }
            $initiate.next();
        } );
    leaves.bonus.space.s( "beginComplete" )
        .with( $displayingWin, ( _, d ) => d )
        .with( $state, ( d, state ) => ({ d, state }) )
        .on( ({ d, state }) => {
            $beginningFeature.next( false );
            if ( d )
            {
                $displayingWin.next( false );
                $interruptWinShow.next();
            }
            leaves.bonus.space.s( "showResult" ).next( state );
            leaves.ui.space.s( "isBonus" ).next( true );
        } );
    
    const $rotating = space.s( "rotating", false );
    barrel.s( "start" )
        .map( () => true )
        .merge( leaves.barrel.space.s( "stop" ).map( () => false ) )
        .subscribe( $rotating );
    
    //spin -> ...
    const $barrelStop = leaves.barrel.space.s( "stop" ).withLatestFrom( $state, ( stop, state ) => state );
    $barrelStop.map( () => undefined ).to( leaves.slot.space.s( "forbidStop" ) );
    $barrelStop.subscribe( space.s( "barrelStop" ) );
    //automatically finish round when no win (can't go risk):
    $barrelStop
        .filter( state =>
            state.type == network.TYPE.REGULAR
            &&
            state.state.stage.win <= 0
            &&
            network.canOnlyGo( network.TYPE.FINAL, state.state )
        )
        .map( () => ({ type : REQUEST_TYPE.TAKE_WIN }) )
        .subscribe( $request );
    //stop button:
    $rotating
        .combineLatest(
            $state,
            ( rotating, state ) =>
            (
                rotating
                ||
                state.type == network.TYPE.FREESPIN
            )
            &&
            state.type != network.TYPE.PRECURSOR
            &&
            state.type != network.TYPE.JACKPOT
         )
        .subscribe( leaves.ui.space.s( "mayStop" ) );
    barrel.s( "hasData" )
        .combineLatest( $rotating, ( hasData, rotating ) => hasData && rotating )
        .any( leaves.slot.space.s( "forbidStop" ), ( can, forbid ) => can && ! forbid )
        .subscribe( leaves.ui.space.s( "canInterruptBarrel" ) );
    
    //display winnings:
    const $winningRegularStop = $barrelStop
        .filter( state =>
            state.type == network.TYPE.REGULAR
            &&
            //people say there can be spins without winnings, but leading to bonus:
            ( state.state.stage.win > 0 || network.cannotGo( network.TYPE.FINAL, state.state ) )
        );
    $winningRegularStop.subscribe( space.s( "winningRegularStop" ) );
    const $showWinSlot = leaves.slot.space.s( "showWin" );
    $winningRegularStop
        .filter( state => network.canOnlyGo( network.TYPE.FINAL, state ) )
        .map( state =>
            ({
                bet : state.server.betValue,
                math : state.state.stage.math,
                win : state.state.stage.win,
            })
        )
        .subscribe( p =>
        {
            $displayingWin.next( true );
            $showWinSlot.next( p );
        } );
    const $showPreFeatureWinSlot = leaves.slot.space.s( "showPreFeatureWin" );
    $winningRegularStop
        .filter( state => network.cannotGo( network.TYPE.FINAL, state.state ) )
        .withLatestFrom( leaves.ui.space.s( "betValue" ), ( state, bet ) => ({
            math : state.state.stage.math,
            bet,
            freeSpinWinMultiplier : state.server.loginData.spec.freeSpinWinMultiplier,
            win : state.state.stage.win,
            bonus : canGo( TYPE.BONUS_1, state ),
            freespinsCount : state.server.freespinsCount
        }) )
        .subscribe( p => {
            $displayingWin.next( true );
            $showPreFeatureWinSlot.next( p );
        } );
    leaves.slot.space.s( "showWinComplete" ).map( () => false ).to( $displayingWin );
    
    $pending
        .withLatestFrom( $displayingWin, ( p, d ) => d )
        .filter( d => d )
        .subscribe( () =>
        {
            $displayingWin.next( false );
            $interruptWinShow.next();
        } );
    
    //display freegame winnings:
    const $freegamesStop = $barrelStop.filter( state => state.type == network.TYPE.FREEGAME );
    
    //freespin with no winning or win display completed:
    const $freespinComplete = space.s( "freespinComplete" );
    $freespinComplete.subscribe( state =>
    {
        if ( network.canGo( network.TYPE.FREESPIN, state ) )
        {
            $initiate.next();
        }
        else if ( network.canGo( network.TYPE.FINISH, state ) )
        {
            $request.next( { type : REQUEST_TYPE.FINISH } );
        }
        else
        {
            //TODO: bonus
        }
    } );
    
    //freespin with nothing:
    $freegamesStop
        .filter( state =>
            state.state.stage.win <= 0 &&
            (
                network.canOnlyGo( network.TYPE.FREESPIN, state )
                ||
                network.canOnlyGo( network.TYPE.FINISH, state )
            )
        )
        .map( state => ({
            math : state.state.stage.math,
            freeSpinWinMultiplier : state.server.loginData.spec.freeSpinWinMultiplier,
            win : state.state.stage.win,
            server : state.server
        }) )
        .subscribe( leaves.freegames.space.s( "noFreeWin" ) );
    const $showWinFreegames = leaves.freegames.space.s( "showWin" );
    //freespin with just normal winnings (no bonus enter):
    $freegamesStop
        .filter( state =>
            state.state.stage.win > 0 &&
            (
                network.canOnlyGo( network.TYPE.FREESPIN, state )
                ||
                network.canOnlyGo( network.TYPE.FINISH, state )
            )
        )
        .withLatestFrom( leaves.ui.space.s( "betValue" ), ( state, bet ) => ({ state, bet }) )
        .subscribe( ({ state, bet }) =>
        {
            $animating.next( true );
            const p = {
                math : state.state.stage.math,
                bet,
                freeSpinWinMultiplier : state.server.loginData.spec.freeSpinWinMultiplier,
                win : state.state.stage.win,
                freespinsCount : state.server.freespinsCount
            };
            $showWinFreegames.next( p );
        } );
    const $showPreFeatureWinFreegames = leaves.freegames.space.s( "showPreFeatureWin" );
    //freespin with bonus enter:
    $freegamesStop
        .filter( state =>
            network.cannotGo( network.TYPE.FINISH, state ) &&
            network.cannotGo( network.TYPE.FREESPIN, state )
        )
        .withLatestFrom( leaves.ui.space.s( "betValue" ), ( state, betValue ) => ({
            math : state.state.stage.math,
            bet : betValue,
            freeSpinWinMultiplier : state.server.loginData.spec.freeSpinWinMultiplier,
            win : state.state.stage.win,
            freespinsCount : state.server.freespinsCount
        }) )
        .subscribe( p =>
        {
            $animating.next( true );
            $showPreFeatureWinFreegames.next( p );
        } );
    //proceed freegames after win display completes:
    leaves.freegames.space.s( "showComplete" )
        .withLatestFrom( $state, ( c, state ) => state )
        .subscribe( state =>
        {
            $animating.next( false );
            $freespinComplete.next( state );
        } );
    leaves.freegames.space.s( "endingComplete" )
        .map( () => false )
        .subscribe( $animating );
    
    const $endingFreespins = leaves.freegames.space.s( "ending" );
    const $endingBonus = leaves.bonus.space.s( "ending" );
    const $endingSuperbonus = leaves.superbonus.space.s( "ending" );
    //display freegames resulting table:
    const $finishing = ui.s( "finishing" );
    $state.on( state =>
    {
        if (
            state.type != network.TYPE.FINISH
            ||
            //some games has "FEATURE_END" state between bonus and freegames:
            cannotGo( TYPE.FINAL, state )
        )
        {
            $finishing.next( FINISHING_STATES.NONE );
            return;
        }
        
        $finishing.next( FINISHING_STATES.SHOWING_TABLE );
        
        const d = {
            math :  state.state.stage.math,
            bet : {
                lines : state.state.line_count,
                multiplier : state.state.multiplier,
            }
        };
        
        switch ( state.state.stage.math.featureType )
        {
            case TYPE.BONUS_1: $endingBonus.next( d ); break;
            case TYPE.BONUS_2: $endingSuperbonus.next( d ); break;
            default: $endingFreespins.next( d );
        }
    } )
    //can't use merge() operator here because it waits for all parents before button can be activated but games use "endingComplete"->"ui:finish" button redirection to skip this stage:
    /*Stream.merge(
        leaves.freegames.space.s( "endingComplete" ),
        leaves.bonus.space.s( "endingComplete" ),
        leaves.superbonus.space.s( "endingComplete" )
    )
    .map( () => FINISHING_STATES.FINISH_INVITATION )
    .to( $finishing );*/
    leaves.freegames.space.s( "endingComplete" )
        .map( () => FINISHING_STATES.FINISH_INVITATION )
        .to( $finishing );
    leaves.bonus.space.s( "endingComplete" )
        .map( () => FINISHING_STATES.FINISH_INVITATION )
        .to( $finishing );
    leaves.superbonus.space.s( "endingComplete" )
        .map( () => FINISHING_STATES.FINISH_INVITATION )
        .to( $finishing );
    
    const $endFreegames = leaves.freegames.space.s( "end" );
    const $endBonus = leaves.bonus.space.s( "end" );
    const $endSuperbonus = leaves.superbonus.space.s( "end" );
    //finish button:
    leaves.ui.space.s( "finish" )
        .withLatestFrom( $state, ( f, state ) => state.state.stage.math )
        .on( math =>
        {
            
            switch ( math.featureType )
            {
                case TYPE.BONUS_1:
                    $finishing.next( FINISHING_STATES.RISK_INVITATION );
                    $endBonus.next( math );
                    break;
                
                case TYPE.BONUS_2:
                    $finishing.next( FINISHING_STATES.RISK_INVITATION );
                    $endSuperbonus.next( math );
                    break;
                
                default:
                    $finishing.next( FINISHING_STATES.ENDING );
                    $endFreegames.next( math );
                    break;
            }
        } );
    leaves.freegames.space.s( "tableHidden" )
        .map( () => FINISHING_STATES.RISK_INVITATION )
        .to( $finishing );
    
    return {
        space,
        barrel,
    };
}




// WEBPACK FOOTER //
// ./src/library/slot.es6